import { httpsCallable } from "firebase/functions";
import { BACKEND_URL } from "./contants";
import { auth, functions } from "./firebase";
import { applyActionCode, checkActionCode } from "firebase/auth";

export const getCurrentUser = () => {
  return auth.currentUser
}
export const verifyToken = async (token) => {
  console.log("token", token)
  try {
    const res = await fetch(`${BACKEND_URL}/verifyToken`, {
      method: "POST",
      body: JSON.stringify({ token: token }),
    });
    const data = await res.json();
    if (!data.email) {
      throw new Error("Token verification failed: email missing");
    }
    return data.email
  } catch (error) {
    throw error;
  }
}

export function updatePassword(email, password) {
  console.log("updatePwd")
  const updatePwd = httpsCallable(functions, 'updatePassword');
  return new Promise((resolve, reject) =>
    updatePwd({ email: email, password: password })
      .then((response) => {
        resolve(response.data.success)
      }).catch((error) => {
        console.log("error", error)
        reject(error)
      })
  )
}

export async function confirmEmail(oobCode) {
  const info = await checkActionCode(auth, oobCode)
  await applyActionCode(auth, oobCode)

  return info.data.email
}